export const FETCHER_CODE_EXPIRED_TOKEN = 412;
export const FETCHER_STATUS_TOKEN = 401;
